export enum USER_ROLES {
  ADMIN = 'admin',
  USER = 'user',
  COALITION_MEMBER = 'coalition member',
  CHEMOSAFE_TOOL_ADMIN = 'chemosafe tool admin',
  CHEMOQUANT_ADMIN = 'chemoquant admin',
}
